<input type="text" [class]="class" [class.is-invalid]="control.touched && control.invalid"
    [class.is-valid]="control.value && control.valid && showIconSuccess === true"
    [class.is-loading]="control.pending && showIconSuccess === true" [id]="id" [name]="id" [title]="title"
    [maxlength]="maxlength" [placeholder]="placeholder" [formControl]="control"
    (keydown.enter)="$event.preventDefault()" #inputSearch />


<div-validation-message [control]="control" [messageRequired]="'Dirección es requerida'">
</div-validation-message>